import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIdentityClient } from "@packsize/authentication";

import { TENANTS_QUERY_KEY } from "./use-tenants";

export type DeleteTenantParams = {
	tenantId: string;
	userId: string;
};

export const useDeleteTenant = () => {
	const { client } = useIdentityClient();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({ tenantId, userId }: DeleteTenantParams) =>
			client.addUserTenant({
				tenantId,
				userId,
				expiresAt: new Date(0).toISOString(),
			}),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: TENANTS_QUERY_KEY });
		},
	});
};
